import {GrammarlyButton} from '@grammarly/editor-sdk-react';
import React, {FC} from 'react';
import styled from 'styled-components';

import {buildInteractionIdProps} from '../../../libs/shared/core/src/helpers/interaction/interactionHelpers';
import {useAppSelector} from '../../helpers/appReduxHelpers';
import {useGrammarlyState} from './grammarlyContext';
import {getIsGrammarlyAllEnabled} from './grammarlySelectors';

/*
 * Constants.
 */

const grammarlyButtonBaseRightOffset = 8;
const grammarlyButtonBaseBottomOffset = 22;

/*
 * Props.
 */

interface GrammarlyButtonHostProps {
  shouldUseBottom?: boolean;
  shouldUseRight?: boolean;
}

/*
 * Style.
 */

const StyledWrapperDiv = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
`;

interface StyledGrammarlyButtonProps {
  $rightSideOffset?: number;
  $bottomOffset?: number;
}

const StyledGrammarlyButton = styled(GrammarlyButton)<StyledGrammarlyButtonProps>`
  position: absolute;
  right: ${(p) => grammarlyButtonBaseRightOffset + (p.$rightSideOffset ?? 0)}px;
  bottom: ${(p) => grammarlyButtonBaseBottomOffset + (p.$bottomOffset ?? 0)}px;
  pointer-events: auto;
`;

/*
 * Component.
 */

export const GrammarlyButtonHost: FC<GrammarlyButtonHostProps> = (props) => {
  const {composerHeight, rightSidebarWidth, scrollbarWidth} = useGrammarlyState();
  const isGrammarlyAllEnabled = useAppSelector(getIsGrammarlyAllEnabled);

  if (!isGrammarlyAllEnabled) {
    return null;
  }

  const rightSideOffset = (rightSidebarWidth ?? 0) + (scrollbarWidth ?? 0);

  return (
    <StyledWrapperDiv>
      <StyledGrammarlyButton
        {...buildInteractionIdProps('grammarly-button')}
        $bottomOffset={props.shouldUseBottom ? composerHeight : 0}
        $rightSideOffset={props.shouldUseRight ? rightSideOffset : 0}
      />
    </StyledWrapperDiv>
  );
};
